import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button } from "@sunwing/wvi-components";
import { Row, Cell } from "../../Grid";
import * as styles from "./CardsContainerGrid.module.scss";

const defaultLabels = {
	loadAll: "Load all",
	loadMore: "Load more",
};

const CardsContainerGrid = ({
	labels: providedLabels,
	numberToShow,
	moreToShow,
	cardsPerRow,
	children,
	className,
}) => {
	const [displayedItems, setDisplayedItems] = useState(numberToShow);
	const [isButtonVisible, setButtonVisibility] = useState(true);
	const [remainingItems, setRemainingItems] = useState(false);
	const labels = { ...defaultLabels, ...providedLabels };

	useEffect(() => {
		if (React.Children.count(children) <= 6) {
			setButtonVisibility(false);
		}
	}, [children]);

	useEffect(() => {
		if (React.Children.count(children) - displayedItems <= moreToShow) {
			setRemainingItems(true);
		}
	}, [children, displayedItems, moreToShow]);

	const showMore = () => {
		const totalItems = React.Children.count(children);
		const itemsShowing = displayedItems + moreToShow;

		if (totalItems >= itemsShowing) {
			setDisplayedItems(itemsShowing);
		} else if (itemsShowing > totalItems) {
			setDisplayedItems(totalItems);
			setButtonVisibility(false);
		}
		if (totalItems === itemsShowing) {
			setButtonVisibility(false);
		}
		if (totalItems - itemsShowing <= moreToShow) {
			setRemainingItems(true);
		}
	};

	const handleOnClick = () => {
		showMore();
	};

	return (
		<>
			<Row cols={cardsPerRow} className={className}>
				{React.Children.map(children, (component, index) => {
					if (index < displayedItems) {
						return <Cell>{component}</Cell>;
					}
					return null;
				})}
			</Row>
			{isButtonVisible && children?.length > numberToShow && (
				<Button
					variant="utility"
					className={styles.loadMore}
					icon="double-chevron-down-micro"
					iconPlacement="right"
					onClick={handleOnClick}>
					{remainingItems ? labels.loadAll : labels.loadMore}
				</Button>
			)}
		</>
	);
};

CardsContainerGrid.propTypes = {
	className: PropTypes.string,
	labels: PropTypes.shape({
		loadAll: PropTypes.string,
		loadMore: PropTypes.string,
	}),
	numberToShow: PropTypes.number,
	moreToShow: PropTypes.number,
	cardsPerRow: PropTypes.number,
	children: PropTypes.node.isRequired,
};

CardsContainerGrid.defaultProps = {
	classNames: undefined,
	labels: defaultLabels,
	numberToShow: 6,
	moreToShow: 6,
	cardsPerRow: 3,
};

export { CardsContainerGrid };
